import { useQuery } from '@tanstack/react-query';
import { fetchSiteSettings } from '@/api/client';

/** Globális kioszk-beállítások (screensaver videó, fejléc logó) — ritkán változik. */
export function useSiteSettings() {
  return useQuery({
    queryKey: ['site-settings'],
    queryFn: fetchSiteSettings,
    staleTime: 5 * 60_000,
  });
}
